import {
    mobileOnly, tabletLandscapeUp, tabletPortraitUp, desktopUp, smallMobile
} from '@styles/breakpoints';
import colors from '@styles/colors';
import { css } from '@emotion/css'

export default {
    recommendedForContainer: css({
        backgroundColor: colors.BEIGE_OVERVIEW,
        marginBottom: 20,
        display: 'block',

        [mobileOnly]: {
            marginTop: 20,
            paddingBottom: 10,
        },

        'button.reset-for': {
            maxWidth: 300,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: 16,
            lineHeight: '145%',
            letterSpacing: '0.01em',
            color: colors.BLUE_EXTRA_LIGHT,
            textTransform: 'capitalize',

            [mobileOnly]: {
                marginBottom: 20,
                maxWidth: '-webkit-fill-available',
                width: '100%',
                marginLeft: 20,
                marginRight: 20,
            },

            '&.mobile': {
                display: 'none',
                [mobileOnly]: {
                    display: 'block',
                },
            },

            '&.desktop': {
                display: 'block',
                [mobileOnly]: {
                    display: 'none',
                },
            },

            'img': {
                marginRight: 16,
            }
        },

        '.recommended-for-header': {
            //maxWidth: 820,

            borderBottom: `1px solid ${colors.BLUE_EXTRA_LIGHT}`,
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            [mobileOnly]: {
                padding: '23px 17px 21px 19px',
                flexDirection: 'column',
                alignItems: 'baseline',
            },
            [tabletPortraitUp]: {
                padding: '23px 17px 21px 19px',
                flexDirection: 'column',
                alignItems: 'baseline',
            },
            [tabletLandscapeUp]: {
                flexDirection: 'row',
                padding: '23px 40px 21px 40px',
            },
            [desktopUp]: {
                padding: '15px 94px 15px 40px',
                alignItems: 'center',
            },
            '.recommended-for-control': {
                display: 'flex',
                alignItems: 'center',
                '&.toggle': {
                    border: 'none',
                    width: '100%',
                    background: 'none',
                    color: colors.BLUE,
                },
                'img.star': {
                    marginRight: 23,
                    marginTop: 10,
                },
                'span': {
                    marginRight: 19,
                    fontWeight: 700,
                    color: colors.BLUE,
                    fontSize: 15,
                    lineHeight: '135%',
                    letterSpacing: '0.02em',
                },
                'button': {
                    border: 0,
                    backgroundColor: colors.TRANSPARENT,
                    padding: 0,
                    transform: 'rotate(180deg)',
                    display: 'flex',
                    alignItems: 'center',

                    [mobileOnly]: {
                        marginLeft: 'auto',
                    },
                },
            },
        },
        '.recommended-for-body': {
            //maxWidth: 820,
            padding: '34px 94px 43px 35px',
            display: 'flex',
            justifyContent: 'space-between',

            [mobileOnly]: {
                padding: 20,
                paddingBottom: 60,
            },

            '.recommended-for-product-wrapper': {
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                width: '100%',
            },
            '.recommended-for-products': {
                display: 'flex',
                flexWrap: 'wrap',
                '.recommended-for-single-product': {
                    maxWidth: 81,
                    width: '100',
                    position: 'relative',
                    marginRight: 28,
                    display: 'block',
                    marginTop: 'auto',

                    '&.bars': {
                        maxWidth: 160,
                        marginBottom: '-20px',

                        '.recommended-for-product-quantity': {
                            bottom: '20px'
                        }
                    },
                    'img': {
                        maxWidth: '100%',
                        height: 'auto',
                    },
                    '.recommended-for-product-quantity': {
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        minWidth: 34,
                        height: 30,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 5,
                        backgroundColor: colors.BLUE,
                        color: colors.WHITE,
                        fontSize: 13,
                        lineHeight: 0,
                    }
                },
            },
            '.recommended-for-see-why': {
                display: 'none',
                // display: 'inline-flex',
                alignItems: 'flex-end',
                'img': {
                    marginRight: 12,
                },
                'span': {
                    position: 'relative',
                    cursor: 'pointer',
                    fontSize: 15,
                    lineHeight: '19px',
                    letterSpacing: '0.01em',
                    marginBottom: 5,
                    color: colors.BLUE,
                    '&:after': {
                        content: "''",
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        left: 0,
                        height: 1,
                        [tabletLandscapeUp]: {
                            bottom: 2,
                        }
                    },
                },
                '&:hover span': {
                    '&:after': {
                        background: colors.BLUE,
                        WebkitAnimation: 'bottomAnim 1s ease-in-out',
                        animation: 'bottomAnim 1s ease-in-out',
                        WebkitAnimationIterationCount: '0.5',
                        animationIterationCount: '0.5',
                        WebkitAnimationFillMode: 'backwards',
                        animationFillMode: 'backwards',
                        '@-webkit-keyframes bottomAnim': {
                            '0%': {
                                left: 0,
                                right: '100%',
                            },
                            '50%': {
                                left: 0,
                                right: 0,
                            },
                            '100%': {
                                left: '100%',
                                right: 0,
                            },
                        },
                        '@keyframes bottomAnim': {
                            '0%': {
                                left: 0,
                                right: '100%',
                            },
                            '50%': {
                                left: 0,
                                right: 0,
                            },
                            '100%': {
                                left: '100%',
                                right: 0,
                            },
                        },
                    },
                },
            }
        },
    })
};